module.exports = __webpack_public_path__ + "img/solution-image06.0a124074.png";